export default __webpack_public_path__ + "static/media/ic-all.296c1a48.svg";